import * as React from "react";
import ReactTooltip from "react-tooltip";
import { LoanTypeList, YearInMalta, ExistingLoan } from "enums";
import "react-datepicker/dist/react-datepicker.css";

interface LoanData {
  loanType: string;
  livingInMaltaApplicant1: string;
  livingInMaltaApplicant2: string;
  existingHomeLoanApplicant1: string;
  existingHomeLoanApplicant2: string;
  applicant1Dob: Date;
  applicant2Dob: Date;
  applicant1Age: number;
  applicant2Age: number;
  retirement1Age: number;
  retirement2Age: number;
  yearsLeftRetirement1Age: number;
  yearsLeftRetirement2Age: number;
  applicant1Income: number;
  applicant2Income: number;
  applicantTotalIncome: number;
  totalCreditCardLimitForApplicant1: number;
  totalCreditCardLimitForApplicant2: number;
  totalCreditCardLimitCombined: number;
  otherMonthlyCommitments1: number;
  otherMonthlyCommitments2: number;
  totalMonthlyCommitments: number;
  currentMonthlyDebts: number;
  homeLoanTerm: any;
  maximumMonthlyLoanPaymentAmount: number;
  maximumLoanPaymentAmount: number;
  monthlyLoanRepayment: number;
  propertyCost: number;
  propertyDepositRequired: number;
  annaulInterestRate: any;
}

export const LoanCalculator: React.FC = () => {
  const varWindow = window as { [key: string]: any };
  const maximumDebthToIncomeRatio = varWindow[
    "maximumDebthToIncomeRatio"
  ] as number;
  const annualInterestRate = varWindow["annualInterestRate"] as number;
  const annualInterestRateIncreased = varWindow[
    "annualInterestRateIncreseadBy150Point"
  ] as number;
  const maximumTerm = 40;
  const now = new Date();
  const yearNow: number = now.getFullYear();
  const [showJointDetails, setShowJointDetails] = React.useState(false);
  const [ageLimitMessage, setAgeLimitMessage] = React.useState(false);
  const [showMaxCommitmentsMessage, setshowMaxCommitmentsMessage] =
    React.useState(false);
  const [otherUserTrigerred1, setOtherUserTrigerred1] = React.useState(false);
  const [otherUserTrigerred2, setOtherUserTrigerred2] = React.useState(false);
  const [showAgeRequiredApplicant1, setShowAgeRequiredApplicant1] =
    React.useState(false);
  const [showAgeRequiredApplicant2, setShowAgeRequiredApplicant2] =
    React.useState(false);
  const [showGrossRequiredApplicant1, setShowGrossRequiredApplicant1] =
    React.useState(false);
  const [showGrossRequiredApplicant2, setShowGrossRequiredApplicant2] =
    React.useState(false);
  const [state, setState] = React.useState<LoanData>({
    loanType: LoanTypeList.SINGLE,
    livingInMaltaApplicant1: YearInMalta.MORE_THAN_5_YEARS,
    livingInMaltaApplicant2: YearInMalta.MORE_THAN_5_YEARS,
    existingHomeLoanApplicant1: ExistingLoan.NO,
    existingHomeLoanApplicant2: ExistingLoan.NO,
    applicant1Dob: new Date(),
    applicant2Dob: new Date(),
    applicant1Age: 0,
    applicant2Age: 0,
    retirement1Age: 0,
    retirement2Age: 0,
    yearsLeftRetirement1Age: 0,
    yearsLeftRetirement2Age: 0,
    applicant1Income: 0,
    applicant2Income: 0,
    applicantTotalIncome: 0,
    totalCreditCardLimitForApplicant1: 0,
    totalCreditCardLimitForApplicant2: 0,
    totalCreditCardLimitCombined: 0,
    otherMonthlyCommitments1: 0,
    otherMonthlyCommitments2: 0,
    totalMonthlyCommitments: 0,
    currentMonthlyDebts: 0,
    homeLoanTerm: "-",
    maximumMonthlyLoanPaymentAmount: 0,
    maximumLoanPaymentAmount: 0,
    monthlyLoanRepayment: 0,
    propertyCost: 0,
    propertyDepositRequired: 0,
    annaulInterestRate: "-",
  });

  return (
    <div className="container-fluid">
      <div className="container">
        <div className="calculator-wrapper">
          <form>
            <div className="row">
              <div id="loan-calculator" className="col d-lg-block">
                <div
                  className={`calculator-container ${
                    !showJointDetails
                      ? "loan-conainter"
                      : "loan-conainter-joint"
                  }`}
                >
                  <div className="spacing-container">
                    <p className="calculator-help-text">
                      {varWindow["loanTranslations"].topText as string}
                    </p>
                    <div className="form-row divColor">
                      <p className="joint-text">
                        {varWindow["loanTranslations"].joint as string}
                      </p>
                      <div
                        // style={{ marginLeft: "20px", marginRight: "30px" }}
                        className="form-check form-check-inline"
                      >
                        <input
                          onChange={(e) =>
                            handleLoanType(LoanTypeList.JOINT, "loanType")
                          }
                          checked={state.loanType === LoanTypeList.JOINT}
                          type="radio"
                          name="loanType"
                          id="joint"
                          className="calc-radio"
                          value={LoanTypeList.JOINT}
                        />
                        <label
                          className="form-check-label"
                          style={{ marginLeft: 8 }}
                        >
                          {" "}
                          Yes{" "}
                        </label>
                      </div>
                      <div className="form-check form-check-inline">
                        <input
                          onChange={(e) =>
                            handleLoanType(LoanTypeList.SINGLE, "loanType")
                          }
                          checked={state.loanType === LoanTypeList.SINGLE}
                          type="radio"
                          name="loanType"
                          id="single"
                          className="calc-radio"
                          value={LoanTypeList.SINGLE}
                        />
                        <label
                          className="form-check-label"
                          style={{ marginLeft: 8 }}
                        >
                          {" "}
                          No{" "}
                        </label>
                      </div>
                    </div>
                    {!showJointDetails ? (
                      <p className="applicant-text">
                        {varWindow["loanTranslations"].applicant as string}
                      </p>
                    ) : (
                      <p className="applicant-text">
                        {varWindow["loanTranslations"].applicant1 as string}
                      </p>
                    )}

                    <div className="form-row">
                      <div className="col-lg-6 col-md-5 col-sm-12">
                        <div className="form-group">
                          <label>
                            {varWindow["loanTranslations"].yourAge as string}
                            <span style={{ color: "#772777" }}>*</span>
                          </label>
                          <input
                            type="number"
                            min={18}
                            max={64}
                            pattern="[0-9]*"
                            onBlur={(e) =>
                              handleAgeValidation(
                                parseInt(e.target.value),
                                "applicant1Age"
                              )
                            }
                            onKeyDown={(e) => handleExcludesCharacters(e)}
                            onChange={(e) =>
                              handleAgeChange(
                                parseInt(e.target.value),
                                "applicant1Age"
                              )
                            }
                            value={
                              state.applicant1Age === 0
                                ? ""
                                : state.applicant1Age
                            }
                            className="form-control"
                            required
                          />
                          {showAgeRequiredApplicant1 ? (
                            <span className="required-field">
                              {varWindow["loanTranslations"].required as string}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-7 col-sm-12">
                        <div className="form-group">
                          <label className="income-label">
                            {varWindow["loanTranslations"].yourIncome as string}
                            <span style={{ color: "#772777" }}>*</span>
                          </label>
                          <div className="inner-addon left-addon">
                            <i className="fa fa-eur"></i>
                            <input
                              placeholder="10,000"
                              className="form-control"
                              type="text"
                              pattern="[0-9]*"
                              onChange={(e) =>
                                handleInputChange(
                                  parseInt(e.target.value),
                                  "applicant1Income"
                                )
                              }
                              value={
                                state.applicant1Income === 0
                                  ? ""
                                  : state.applicant1Income
                              }
                            />
                            {showGrossRequiredApplicant1 ? (
                              <span className="required-field">
                                {
                                  varWindow["loanTranslations"]
                                    .required as string
                                }
                              </span>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <ReactTooltip
                      id="monthlyCommitmentsTip"
                      place="top"
                      effect="solid"
                    >
                      {varWindow["loanTranslations"].monthlyTip as string}
                    </ReactTooltip>
                    <div className="form-row">
                      <div className="col">
                        <div className="form-group">
                          <label>
                            {
                              varWindow["loanTranslations"]
                                .monthlyCommitments as string
                            }{" "}
                            <i
                              data-tip
                              data-for="monthlyCommitmentsTip"
                              className="fa fa-info-circle"
                              aria-hidden="true"
                            ></i>
                          </label>
                          <div className="inner-addon left-addon">
                            <i className="fa fa-eur"></i>
                            <input
                              className="form-control"
                              placeholder="500"
                              type="text"
                              pattern="[0-9]*"
                              onChange={(e) =>
                                handleMonthlyCommitmentsChange(
                                  parseInt(e.target.value),
                                  "otherMonthlyCommitments1"
                                )
                              }
                              value={
                                state.otherMonthlyCommitments1 === 0 &&
                                !otherUserTrigerred1
                                  ? ""
                                  : state.otherMonthlyCommitments1
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    {showJointDetails ? (
                      <div>
                        <hr />
                        <p className="applicant-text">
                          {varWindow["loanTranslations"].applicant2 as string}
                        </p>
                        <div className="form-row">
                          <div className="col-lg-6 col-md-5 col-sm-12">
                            <div className="form-group">
                              <label>
                                {
                                  varWindow["loanTranslations"]
                                    .yourAge as string
                                }
                                <span style={{ color: "#772777" }}>*</span>
                              </label>
                              <input
                                type="number"
                                min={18}
                                max={64}
                                pattern="^(1[8-9]|2[0-9]|6[0-5])$"
                                onKeyDown={(e) => handleExcludesCharacters(e)}
                                onBlur={(e) =>
                                  handleAgeValidation(
                                    parseInt(e.target.value),
                                    "applicant2Age"
                                  )
                                }
                                onChange={(e) =>
                                  handleAgeChange(
                                    parseInt(e.target.value),
                                    "applicant2Age"
                                  )
                                }
                                value={
                                  state.applicant2Age === 0
                                    ? ""
                                    : state.applicant2Age
                                }
                                className="form-control"
                                required
                              />
                              {showAgeRequiredApplicant2 ? (
                                <span className="required-field">
                                  {
                                    varWindow["loanTranslations"]
                                      .required as string
                                  }
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-7 col-sm-12">
                            <div className="form-group">
                              <label className="income-label">
                                {
                                  varWindow["loanTranslations"]
                                    .yourIncome as string
                                }
                                <span style={{ color: "#772777" }}>*</span>
                              </label>
                              <div className="inner-addon left-addon">
                                <i className="fa fa-eur"></i>
                                <input
                                  placeholder="10,000"
                                  className="form-control"
                                  type="text"
                                  pattern="[0-9]*"
                                  onChange={(e) =>
                                    handleInputChange(
                                      parseInt(e.target.value),
                                      "applicant2Income"
                                    )
                                  }
                                  value={
                                    state.applicant2Income === 0
                                      ? ""
                                      : state.applicant2Income
                                  }
                                />
                                {showGrossRequiredApplicant2 ? (
                                  <span className="required-field">
                                    {
                                      varWindow["loanTranslations"]
                                        .required as string
                                    }
                                  </span>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <ReactTooltip
                          id="monthlyCommitmentsTip2"
                          place="top"
                          effect="solid"
                        >
                          {varWindow["loanTranslations"].monthlyTip as string}
                        </ReactTooltip>
                        <div className="form-row">
                          <div className="col">
                            <div className="form-group">
                              <label>
                                {
                                  varWindow["loanTranslations"]
                                    .monthlyCommitments as string
                                }{" "}
                                <i
                                  data-tip
                                  data-for="monthlyCommitmentsTip2"
                                  className="fa fa-info-circle"
                                  aria-hidden="true"
                                >
                                  {" "}
                                </i>
                              </label>
                              <div className="inner-addon left-addon">
                                <i className="fa fa-eur"></i>
                                <input
                                  className="form-control"
                                  placeholder="500"
                                  type="text"
                                  pattern="[0-9]*"
                                  onChange={(e) =>
                                    handleMonthlyCommitmentsChange(
                                      parseInt(e.target.value),
                                      "otherMonthlyCommitments2"
                                    )
                                  }
                                  value={
                                    state.otherMonthlyCommitments2 === 0 &&
                                    !otherUserTrigerred2
                                      ? ""
                                      : state.otherMonthlyCommitments2
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    <div className="row">
                      <div className="col-md-12 text-center">
                        {ageLimitMessage ? (
                          <span className="required-field age-field">
                            {varWindow["loanTranslations"].ageLimit as string}
                          </span>
                        ) : (
                          ""
                        )}
                        {showMaxCommitmentsMessage ? (
                          <span className="required-field age-field">
                            {
                              varWindow["loanTranslations"]
                                .monthlyCommitmentsLimit as string
                            }
                          </span>
                        ) : (
                          ""
                        )}
                        <button
                          className="btn btn-whole"
                          type="button"
                          onClick={() => getResult()}
                        >
                          {varWindow["loanTranslations"].calculate as string}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-1 d-none d-sm-none d-lg-block">
                <div
                  className={`calculator-arrow ${
                    showJointDetails
                      ? " calculator-arrow-loan-extra"
                      : "calculator-arrow-loan"
                  }`}
                >
                  <i className="fa fa-chevron-right"></i>
                </div>
              </div>
              <div id="loan-calculator-result" className="col d-lg-block">
                <div
                  className={`calculator-container ${
                    !showJointDetails
                      ? "loan-conainter"
                      : "loan-conainter-joint"
                  }`}
                >
                  <div className="spacing-container">
                    <p className="result-title">
                      {varWindow["loanTranslations"].yourResults as string}
                    </p>
                    <div className="output-section">
                      <label>
                        {
                          varWindow["loanTranslations"]
                            .annualInterestRate as string
                        }
                      </label>
                      <span className="output">
                        {state.annaulInterestRate !== "-"
                          ? state.annaulInterestRate + "%"
                          : "-"}
                      </span>
                    </div>
                    <div className="output-section">
                      <label>
                        {
                          varWindow["loanTranslations"]
                            .monthlyLoanRepayment as string
                        }
                      </label>
                      <span className="output">
                        &euro;
                        {isNaN(state.monthlyLoanRepayment)
                          ? 0
                          : state.monthlyLoanRepayment.toLocaleString(
                              undefined,
                              { maximumFractionDigits: 2 }
                            )}
                      </span>
                    </div>
                    <div className="output-section">
                      <label>
                        {varWindow["loanTranslations"].loanDuration as string}
                      </label>
                      <span className="output">{state.homeLoanTerm}</span>
                    </div>
                    <div className="output-section">
                      <label>
                        {varWindow["loanTranslations"].contribution as string}
                      </label>
                      <span className="output">
                        &euro;
                        {state.propertyDepositRequired.toLocaleString(
                          undefined,
                          { maximumFractionDigits: 2 }
                        )}
                      </span>
                    </div>
                  </div>
                  <div className="result-container">
                    <div className="spacing-container">
                      <span>
                        {varWindow["loanTranslations"].maxLoanAmount as string}
                      </span>
                      <span className="total-cost-text">
                        &euro;
                        {state.maximumLoanPaymentAmount.toLocaleString(
                          undefined,
                          { maximumFractionDigits: 2 }
                        ) + ".00"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );

  function handleExcludesCharacters(e: any) {
    var invalidChars = ["-", "+", "e"];
    if (invalidChars.includes(e.key)) {
      e.preventDefault();
    }
  }

  function handleLoanType(value: string, name: string) {
    clearApplicant2Details();
    if (value === LoanTypeList.JOINT) {
      setShowJointDetails(true);
    } else {
      setShowJointDetails(false);
    }
    setState((f) => ({ ...f, [name]: value }));
  }

  function handleMonthlyCommitmentsChange(value: number, name: string) {
    let otherMonthlyCommitmentsCombined: number = 0;
    if (!isNaN(value)) {
      if (name === "otherMonthlyCommitments1") {
        setOtherUserTrigerred1(true);
        otherMonthlyCommitmentsCombined = Math.round(
          value + state.otherMonthlyCommitments2
        );
      } else {
        setOtherUserTrigerred2(true);
        otherMonthlyCommitmentsCombined = Math.round(
          value + state.otherMonthlyCommitments1
        );
      }
    } else {
      setOtherUserTrigerred1(false);
      setOtherUserTrigerred2(false);
      value = 0;
    }

    setState((f) => ({
      ...f,
      [name]: Math.round(value),
      totalMonthlyCommitments: otherMonthlyCommitmentsCombined,
    }));
    workCurrentMonthlyDebts(
      state.totalCreditCardLimitCombined,
      otherMonthlyCommitmentsCombined
    );
  }

  function handleAgeValidation(value: number, name: string) {
    if (value < 18) {
      let stateData = { [name]: 0 };
      setState((f) => ({ ...f, ...stateData }));
    }

    if (value > 64) {
      setAgeLimitMessage(true);
      let stateData = { [name]: 0 };
      setState((f) => ({ ...f, ...stateData }));
    }

    if (value >= 18 && value <= 64) {
      setAgeLimitMessage(false);
    }
  }

  function handleAgeChange(value: number, name: string) {
    let stateData = { [name]: value };

    let age = 0;
    let retirementAge = 0;
    let yearLeftToRetire = 0;

    if (value) {
      age = value;
      retirementAge = getRetirmentAge(yearNow - age);
      yearLeftToRetire = retirementAge - age;
    }

    if (name === "applicant1Age") {
      stateData = {
        ...stateData,
        applicant1Age: age,
        retirement1Age: retirementAge,
        yearsLeftRetirement1Age: yearLeftToRetire,
      };
    } else {
      stateData = {
        ...stateData,
        applicant2Age: age,
        retirement2Age: retirementAge,
        yearsLeftRetirement2Age: yearLeftToRetire,
      };
    }

    setState((f) => ({ ...f, ...stateData }));
  }

  function handleInputChange(value: number, name: string) {
    let applicantTotalIncome = 0;
    if (!isNaN(value)) {
      if (name === "applicant1Income") {
        applicantTotalIncome = value + state.applicant2Income;
      } else {
        applicantTotalIncome = value + state.applicant1Income;
      }
    } else {
      value = 0;
    }

    setState((f) => ({
      ...f,
      [name]: value,
      applicantTotalIncome: applicantTotalIncome,
    }));
  }

  function getRetirmentAge(year: number) {
    if (year <= 1955) {
      return 62;
    } else if (year <= 1958) {
      return 63;
    } else if (year <= 1961) {
      return 64;
    } else {
      return 65;
    }
  }

  function workCurrentMonthlyDebts(
    totalCreditCardLimit: number,
    otherMonthlyCommitments: number
  ) {
    let currentMonthlyDebts = 0;
    if (state.loanType === LoanTypeList.NONE) {
      return;
    } else {
      currentMonthlyDebts = totalCreditCardLimit + otherMonthlyCommitments;
    }
    setState((f) => ({ ...f, currentMonthlyDebts: currentMonthlyDebts }));
  }

  function getResult() {
    setshowMaxCommitmentsMessage(false);
    let applicantTotalIncome: number = 0;
    let totalCreditLimit: number = 0;
    let totalMonthlyCommitments: number = 0;
    let totalMonthlyDebts: number = 0;
    let maximumMonthlyLoanRepayment: number = 0;
    let homeLoanTerm: number = maximumTerm;
    let maximumLoanPaymentAmount = 0;
    let monthlyLoanRepayment = 0;
    let propertyCost = 0;
    let propertyDepositRequired: number = 0;

    setState((f) => ({
      ...f,
      totalMonthlyCommitments: totalMonthlyCommitments,
      applicantTotalIncome: applicantTotalIncome,
      totalCreditCardLimitCombined: totalCreditLimit,
      homeLoanTerm: 0,
      currentMonthlyDebts: totalMonthlyDebts,
      maximumMonthlyLoanPaymentAmount: maximumMonthlyLoanRepayment,
      maximumLoanPaymentAmount: maximumLoanPaymentAmount,
      monthlyLoanRepayment: monthlyLoanRepayment,
      propertyCost: propertyCost,
      propertyDepositRequired: propertyDepositRequired,
      annaulInterestRate: annualInterestRate,
    }));

    if (window.innerWidth <= 767) {
      document.getElementById("loan-calculator-result")?.scrollIntoView({
        behavior: "smooth",
      });
    }

    if (state.loanType === LoanTypeList.NONE) {
      return;
    } else if (state.loanType === LoanTypeList.SINGLE) {
      clearApplicant2Details();
      if (
        state.livingInMaltaApplicant1 === YearInMalta.LESS_THAN_5_YEARS ||
        state.existingHomeLoanApplicant1 === ExistingLoan.YES
      ) {
        return;
      }

      if (state.applicant1Age > 64) {
        setAgeLimitMessage(true);
      } else {
        setAgeLimitMessage(false);
      }

      if (state.applicant1Age === 0) {
        setShowAgeRequiredApplicant1(true);
      } else {
        setShowAgeRequiredApplicant1(false);
      }

      if (state.applicant1Income === 0) {
        setShowGrossRequiredApplicant1(true);
      } else {
        setShowGrossRequiredApplicant1(false);
      }

      if (
        state.applicant1Income === 0 ||
        state.applicant1Age === 0 ||
        state.applicant1Age > 64
      ) {
        return;
      }

      if (
        state.applicant1Age < 18 ||
        state.applicant1Age > state.retirement1Age
      ) {
        return;
      }

      if (
        state.otherMonthlyCommitments1 >=
        (state.applicant1Income / 12) * 0.25
      ) {
        setshowMaxCommitmentsMessage(true);
        return;
      }

      applicantTotalIncome = getTotalGrossIncome(state.applicant1Income, 0);
      totalCreditLimit = getTotalCreditLimit(
        state.totalCreditCardLimitForApplicant1,
        0
      );
      totalMonthlyCommitments = getOtherMonthlyCommitments(
        state.otherMonthlyCommitments1,
        0
      );
      if (state.yearsLeftRetirement1Age < maximumTerm) {
        homeLoanTerm = state.yearsLeftRetirement1Age - 1;
      }
    } else {
      if (
        state.livingInMaltaApplicant1 === YearInMalta.LESS_THAN_5_YEARS ||
        state.livingInMaltaApplicant2 === YearInMalta.LESS_THAN_5_YEARS
      ) {
        return;
      }

      if (
        state.existingHomeLoanApplicant1 === ExistingLoan.YES ||
        state.existingHomeLoanApplicant2 === ExistingLoan.YES
      ) {
        return;
      }

      if (state.applicant1Age > 64 || state.applicant2Age > 64) {
        setAgeLimitMessage(true);
      } else {
        setAgeLimitMessage(false);
      }

      if (state.applicant1Age === 0) {
        setShowAgeRequiredApplicant1(true);
      } else {
        setShowAgeRequiredApplicant1(false);
      }

      if (state.applicant2Age === 0) {
        setShowAgeRequiredApplicant2(true);
      } else {
        setShowAgeRequiredApplicant2(false);
      }

      if (state.applicant1Income === 0) {
        setShowGrossRequiredApplicant1(true);
      } else {
        setShowGrossRequiredApplicant1(false);
      }

      if (state.applicant2Income === 0) {
        setShowGrossRequiredApplicant2(true);
      } else {
        setShowGrossRequiredApplicant2(false);
      }

      if (
        state.applicant1Income === 0 ||
        state.applicant2Age === 0 ||
        state.applicant1Income === 0 ||
        state.applicant2Income === 0 ||
        state.applicant1Age > 64 ||
        state.applicant2Age > 64
      ) {
        return;
      }

      if (
        state.applicant1Age < 18 ||
        state.applicant1Age > state.retirement1Age
      ) {
        return;
      }

      if (
        state.applicant2Age < 18 ||
        state.applicant2Age > state.retirement2Age
      ) {
        return;
      }

      applicantTotalIncome = getTotalGrossIncome(
        state.applicant1Income,
        state.applicant2Income
      );
      totalCreditLimit = getTotalCreditLimit(
        state.totalCreditCardLimitForApplicant1,
        state.totalCreditCardLimitForApplicant2
      );
      totalMonthlyCommitments = getOtherMonthlyCommitments(
        state.otherMonthlyCommitments1,
        state.otherMonthlyCommitments2
      );

      if (state.totalMonthlyCommitments >= (applicantTotalIncome / 12) * 0.25) {
        setshowMaxCommitmentsMessage(true);
        return;
      }

      const minimumRetirementAge: number = Math.min(
        state.yearsLeftRetirement1Age,
        state.yearsLeftRetirement2Age
      );
      if (minimumRetirementAge < maximumTerm) {
        homeLoanTerm = minimumRetirementAge - 1;
      }
    }

    if (applicantTotalIncome === 0) {
      return;
    }

    totalMonthlyDebts = totalCreditLimit + totalMonthlyCommitments;
    maximumMonthlyLoanRepayment =
      ((applicantTotalIncome / 12) * maximumDebthToIncomeRatio) / 100 -
      totalMonthlyDebts;
    maximumLoanPaymentAmount = Number(
      Math.ceil(
        (maximumMonthlyLoanRepayment *
          (1 -
            1 /
              Math.pow(
                1 + annualInterestRateIncreased / 100 / 12,
                homeLoanTerm * 12
              ))) /
          (annualInterestRateIncreased / 100 / 12)
      ).toFixed(2)
    );
    monthlyLoanRepayment = Number(
      (
        (maximumLoanPaymentAmount *
          (annualInterestRate / 100 / 12) *
          Math.pow(1 + annualInterestRate / 100 / 12, homeLoanTerm * 12)) /
        (Math.pow(1 + annualInterestRate / 100 / 12, homeLoanTerm * 12) - 1)
      ).toFixed(2)
    );
    propertyCost = Math.round((maximumLoanPaymentAmount * 100) / 90);
    propertyDepositRequired = Math.ceil((propertyCost * 10) / 100);

    setState((f) => ({
      ...f,
      totalMonthlyCommitments: totalMonthlyCommitments,
      applicantTotalIncome: applicantTotalIncome,
      totalCreditCardLimitCombined: totalCreditLimit,
      homeLoanTerm: homeLoanTerm,
      currentMonthlyDebts: totalMonthlyDebts,
      maximumMonthlyLoanPaymentAmount: maximumMonthlyLoanRepayment,
      maximumLoanPaymentAmount: maximumLoanPaymentAmount,
      monthlyLoanRepayment: monthlyLoanRepayment,
      propertyCost: propertyCost,
      propertyDepositRequired: propertyDepositRequired,
      annaulInterestRate: annualInterestRate,
    }));
  }

  function getOtherMonthlyCommitments(
    applicant1Commitments: number,
    applicant2Commitments: number
  ) {
    return Number((applicant1Commitments + applicant2Commitments).toFixed(2));
  }

  function getTotalGrossIncome(
    applicant1Income: number,
    applicant2Income: number
  ) {
    return applicant1Income + applicant2Income;
  }

  function getTotalCreditLimit(
    applicant1CreditLimit: number,
    applicant2CreditLimit: number
  ) {
    return Number(
      (((applicant1CreditLimit + applicant2CreditLimit) * 5) / 100).toFixed(2)
    );
  }

  function clearApplicant2Details() {
    setState((f) => ({
      ...f,
      livingInMaltaApplicant2: "0",
      existingHomeLoanApplicant2: "0",
      applicant2Dob: new Date(),
      applicant2Age: 0,
      retirement2Age: 0,
      yearsLeftRetirement2Age: 0,
      applicant2Income: 0,
      totalCreditCardLimitForApplicant2: 0,
      otherMonthlyCommitments2: 0,
    }));
  }
};
